import { matchPath } from 'react-router-dom';
import template from '../../helpers/template';
import router from '../../configRouter';
import config from '../../config';

const templateSettings = {
    matcher: /:([a-zA-Z_$][a-zA-Z0-9_$]*)/g,
    from: /:/i,
    to: null,
};

const isAbsUrl = (s) => /^https?:\/\//i.test(s || '');
const isSchemeOnly = (s) => /^https?:\/\/$/i.test(s || '');

const safeOrigin = () => {
    try {
        if (typeof window !== 'undefined' && window.location) return window.location.origin;
    } catch {}
    return '/';
};

const normalizeBase = (base) => {
    if (!base) return '/';
    if (isSchemeOnly(base)) return safeOrigin();
    if (isAbsUrl(base)) return base.replace(/\/+$/, '');
    return ('/' + String(base).replace(/^\/+|\/+$/g, '')).replace(/\/+$/, '') || '/';
};

const join = (base, tail) => {
    if (!tail) return normalizeBase(base);
    if (isAbsUrl(tail)) return tail;
    const b = normalizeBase(base);
    if (isAbsUrl(b)) return `${b}/${String(tail).replace(/^\/+/, '')}`;
    const p = `/${String(tail).replace(/^\/+/, '')}`;
    return (b === '/' ? p : `${b}${p}`).replace(/\/{2,}/g, '/');
};

const getItem = (key) => router.find((r) => r.key === key) || null;
const getItemPath = (item) => (item && item.params && item.params.path) || '/';

export const getPath = (keyOrPath, params) => {
    const isPath = typeof keyOrPath === 'string' && (keyOrPath.startsWith('/') || isAbsUrl(keyOrPath));
    let path = isPath ? keyOrPath : getItemPath(getItem(keyOrPath));

    if (params) path = template(path, params, templateSettings);

    if (!isAbsUrl(path)) path = `/${String(path).replace(/^\/+/, '')}`;

    const base = normalizeBase(config.defaultRoute);
    if (isAbsUrl(base)) return join(base, path);

    return path;
};

export const getOriginPath = (pathname) => {
    const pathOnly = String(pathname || '').replace(/^https?:\/\/[^/]+/i, '');
    const found = router.find((r) => {
        const patt = getItemPath(r);
        if (patt === pathOnly) return true;
        const m = matchPath(pathOnly, { path: patt, end: false });
        return !!m;
    });
    return (found && getItemPath(found)) || '/';
};

export const isMatch = (key, curPath, params) => {
    const target = params ? getPath(key, params) : getPath(key);
    if (isAbsUrl(target)) {
        try {
            const u = new URL(target);
            return u.pathname === curPath;
        } catch {
            return false;
        }
    }
    return target === curPath;
};
